import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import theme from "@shared/utils/themeColors";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FeedLeftContent } from "../components/feed/FeedLeftContent";
import { SinglePost } from "../components/feed/SinglePost";
import { usePostStore } from "../store/postStore";

export default function PostDetail() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { getPost, currentPost, loading, error } = usePostStore();

  useEffect(() => {
    if (id) {
      getPost(id).catch(() => {
        navigate("/community");
      });
    }
  }, [id, getPost, navigate]);

  return (
    <AuthenticatedLayout
      isLoading={loading}
      error={error ? new Error(error) : null}
      pageHeader={{
        title: "Post",
      }}
    >
      <div className="px-4 sm:px-6 lg:px-8 py-8 md:py-0 w-full max-w-9xl mx-auto">
        <div className="xl:flex">
          {/* Left + Middle content */}
          <div className="md:flex flex-1">
            {/* Left content */}
            <FeedLeftContent />

            {/* Middle content */}
            <div className="flex-1 md:ml-8 xl:mx-4 2xl:mx-8">
              <div className="md:py-8">
                {currentPost && (
                  <div className={`${theme.bg.primary} rounded-lg shadow`}>
                    <SinglePost post={currentPost} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
